import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useNavigate } from "react-router-dom";
import "./formTitle.css";
import "./themePlaceholder.css";
import FormHeader from "../common/FormHeader";

function LSERCallout() {
  const navigate = useNavigate();
  const clientSigRef = useRef(null);
  const engineerSigRef = useRef(null);
  const [form, setForm] = useState({
    customerName: "",
    jobNumber: "",
    taylorsJobNumber: "",
    site: "",
    date: "",
    engineer: "",
    timeOn: "",
    timeOff: "",
    telephone: "",
    description: "",
    clientSignature: "",
    engineerSignature: ""
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue = name === "telephone" ? value.replace(/[^0-9]/g, "").slice(0, 12) : value;
    setForm({ ...form, [name]: nextValue });
  };

  // Signature pad handlers
  const clearSignature = (who) => () => {
    if (who === "client") {
      clientSigRef.current.clear();
      setForm(prev => ({ ...prev, clientSignature: "" }));
    } else {
      engineerSigRef.current.clear();
      setForm(prev => ({ ...prev, engineerSignature: "" }));
    }
  };

  const saveSignature = (who) => () => {
    if (who === "client" && !clientSigRef.current.isEmpty()) {
      setForm(prev => ({
        ...prev,
        clientSignature: clientSigRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
    if (who === "engineer" && !engineerSigRef.current.isEmpty()) {
      setForm(prev => ({
        ...prev,
        engineerSignature: engineerSigRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("LSER Call Out Form submitted!");
    navigate(-1);
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
        {/* Back Button - same as SiteRegister.js */}
       
        <div className="card shadow-sm rounded-4 p-4">
          <h2
            className="text-center text-white py-2 mb-4 rounded"
            style={{
              backgroundColor: "#8b1634",
              letterSpacing: "1px",
              fontSize: "1.8rem"
            }}
          >
            LSER Form
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* Customer Name */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Customer Name</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-user" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="text" className="form-control" name="customerName" value={form.customerName} onChange={handleChange} required placeholder="Customer Name" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* S/E Job number */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">S/E Job number</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-hashtag" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="text" className="form-control" name="jobNumber" value={form.jobNumber} onChange={handleChange} required placeholder="S/E Job number" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Taylor's Job number */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Taylor's Job number</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-hashtag" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="text" className="form-control" name="taylorsJobNumber" value={form.taylorsJobNumber} onChange={handleChange} placeholder="Taylor's Job number" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Site */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Site</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-map-marker" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="text" className="form-control" name="site" value={form.site} onChange={handleChange} required placeholder="Site" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Date */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Date</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-calendar" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="date" className="form-control" name="date" value={form.date} onChange={handleChange} required placeholder="Date" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Engineer */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Engineer</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-user" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="text" className="form-control" name="engineer" value={form.engineer} onChange={handleChange} required placeholder="Engineer" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Time On */}
              <div className="col-md-4">  
                <label className="form-label fw-semibold text-secondary">Time On</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-clock-o" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="time" className="form-control" name="timeOn" value={form.timeOn} onChange={handleChange} required placeholder="Time On" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Time Off */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Time Off</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-clock-o" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="time" className="form-control" name="timeOff" value={form.timeOff} onChange={handleChange} required placeholder="Time Off" style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
                </div>
              </div>
              {/* Telephone No. */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Telephone No.</label>
                <div style={{ position: "relative" }}>
                  <i className="fa fa-phone" style={{
                    position: "absolute", left: "18px", top: "50%",
                    transform: "translateY(-50%)", color: "#8b1634", fontSize: "1.1rem"
                  }}></i>
                  <input type="text" className="form-control" name="telephone" value={form.telephone} onChange={handleChange} required placeholder="Telephone No." style={{
                    background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "40px"
                  }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} maxLength={12} inputMode="numeric" pattern="[0-9]*" />
                </div>
              </div>
              {/* Description of Works */}
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Description of Works</label>
                <textarea className="form-control" name="description" value={form.description} onChange={handleChange} placeholder="Description of Works" style={{
                  background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem", paddingLeft: "18px", minHeight: "70px"
                }} onFocus={e => e.target.style.borderColor = "#8b1634"} onBlur={e => e.target.style.borderColor = "#eaf0fe"} />
              </div>
              {/* Client Signature */}
              <div className="col-md-4 mb-3">
                <div className="fw-bold mb-2" style={{ color: '#8b1634' }}>Client Signature</div>
                <div style={{
                  width: '100%',
                  border: '2px solid #8b1634',
                  borderRadius: '18px',
                  background: '#e9cfd6',
                  padding: '0.5rem',
                  textAlign: 'left',
                  position: 'relative',
                  minHeight: '120px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}>
                  <SignatureCanvas
                    ref={clientSigRef}
                    penColor="#8b1634"
                    backgroundColor="#e9cfd6"
                    clearOnResize={false}
                    velocityFilterWeight={0.7}
                    minWidth={1}
                    maxWidth={2.5}
                    dotSize={1.5}
                    throttle={16}
                    canvasProps={{
                      width: window.innerWidth > 600 ? 350 : 300,
                      height: 100,
                      style: {
                        width: '100%',
                        height: '100px',
                        border: 'none',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        display: 'block',
                        touchAction: 'none'
                      }
                    }}
                    onEnd={saveSignature("client")}
                  />
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '4px'
                  }}>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-pill px-3"
                      style={{
                        background: 'transparent',
                        color: '#8b1634',
                        borderColor: '#8b1634'
                      }}
                      onClick={clearSignature("client")}>
                      Clear
                    </button>
                  </div>
                </div>
              </div>
              {/* Engineer Signature */}
              <div className="col-md-4 mb-3">
                <div className="fw-bold mb-2" style={{ color: '#8b1634' }}>Engineer Signature</div>
                <div style={{
                  width: '100%',
                  border: '2px solid #8b1634',
                  borderRadius: '18px',
                  background: '#e9cfd6',
                  padding: '0.5rem',
                  textAlign: 'left',
                  position: 'relative',
                  minHeight: '120px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}>
                  <SignatureCanvas
                    ref={engineerSigRef}
                    penColor="#8b1634"
                    backgroundColor="#e9cfd6"
                    clearOnResize={false}
                    velocityFilterWeight={0.7}
                    minWidth={1}
                    maxWidth={2.5}
                    dotSize={1.5}
                    throttle={16}
                    canvasProps={{
                      width: window.innerWidth > 600 ? 350 : 300,
                      height: 100,
                      style: {
                        width: '100%',
                        height: '100px',
                        border: 'none',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        display: 'block',
                        touchAction: 'none'
                      }
                    }}
                    onEnd={saveSignature("engineer")}
                  />
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '4px'
                  }}>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm rounded-pill px-3"
                      style={{
                        background: 'transparent',
                        color: '#8b1634',
                        borderColor: '#8b1634'
                      }}
                      onClick={clearSignature("engineer")}>
                      Clear
                    </button>
                  </div>
                </div>
              </div>
              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2"
                  style={{
                    backgroundColor: "#8b1634",
                    borderRadius: "30px",
                    boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                  }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LSERCallout;
